import React, { useState, useEffect, useRef } from "react";
import "./Agents.css";
import AgentsTabs from "./AgentsTab";
import Closure from './Closure';
import Champion from "./Champion";
import DeliveryExcellence from "./DeliveryExcellence";
import Renewal from "./Renewal";


export default function Agents({ active_tab_key }) {

   const [activeTab, setActiveTab] = useState('closure');
   const contentRef = useRef(null);
   const [copied, setCopied] = useState(false);

   useEffect(() => {
     return () => {
       contentRef.current = null; // Cleanup on unmount
     };
   }, []);

  //  const decodeTab = (currentTab) => {
  //     switch (currentTab) {
  //       case 'closure':
  //         return 'Closure';
  //       case 'champion':
  //         return 'Champion';
  //       case 'delivery_excellence':
  //         return 'Delivery Excellence';
  //       case 'renewal':
  //           return 'Renewal';
  //       default:
  //         return 'Unknown Tab';
  //     }
  //  };

   function getPlainTextFromCell(cell) {
    if (!cell) return "";

    // Clone so we don’t affect original DOM
    const clone = cell.cloneNode(true);

    // Replace <br> with newline
    clone.querySelectorAll('br').forEach(br => br.replaceWith('\n'));

    // Replace <li> with newline + bullet (optional)
    clone.querySelectorAll('li').forEach(li => {
      const text = li.textContent.trim();
      li.replaceWith(document.createTextNode('\n' + text));
    });

    // Final clean text
    return clone.textContent.trim();
  }

   const handleCopy = async () => {
    const element = contentRef.current;
    if (!element) return;

    const lines = [];

    // Info rows
    const rowElements = element.querySelectorAll(".row");
    rowElements.forEach((row) => {
      const label = row.querySelector(".overview_head_agents")?.textContent?.trim() || "";
      const value = row.querySelector(".subhead_content")?.textContent?.trim() || "";
      lines.push(`${label.padEnd(25)}: ${value}`);
    });

    lines.push("");
    lines.push("Result:");

    const tables = element.querySelectorAll(".closure_result table");

    tables.forEach((table, index) => {
      if (tables.length > 1) lines.push(`\nTable ${index + 1}:`);

      const rawRows = Array.from(table.querySelectorAll("tr")).map((tr) =>
        Array.from(tr.children).map(cell => getPlainTextFromCell(cell))
      );

      // Normalize
      const maxCols = Math.max(...rawRows.map(r => r.length));
      const normalized = rawRows.map(r => [...r, ...Array(maxCols - r.length).fill("")]);

      const colWidths = Array(maxCols).fill(0);
      normalized.forEach(row =>
        row.forEach((cell, i) => {
          const longestLine = cell.split("\n").reduce((a, b) => a.length > b.length ? a : b, "");
          colWidths[i] = Math.max(colWidths[i], longestLine.length);
        })
      );

      const formatRow = (row) => {
        const splitRows = row.map((cell, i) => cell.split("\n"));
        const maxLines = Math.max(...splitRows.map(r => r.length));
        const out = [];

        for (let i = 0; i < maxLines; i++) {
          const line = splitRows.map((r, j) => (r[i] || "").padEnd(colWidths[j]));
          out.push("| " + line.join(" | ") + " |");
        }

        return out.join("\n");
      };

      const border = "| " + colWidths.map(w => "-".repeat(w)).join(" | ") + " |";

      normalized.forEach((row, i) => {
        if (i === 1) lines.push(border);
        lines.push(formatRow(row));
      });

      lines.push("");
    });

    const finalText = lines.join("\n");

    navigator.clipboard.writeText(finalText)
      .then(() => setCopied(true))
      .catch((err) => console.error("Copy failed:", err));
      // .then(() => alert("Copied with full content (including inline tags & lists)!"))

    setTimeout(() => setCopied(false), 2000);
  };

  const exportTablesToCSV = () => {
    const element = contentRef.current;
    if (!element) return;

    const tables = element.querySelectorAll(".closure_result table");
    if (tables.length === 0) return;

    let csvContent = "";

    tables.forEach((table, index) => {
      if (tables.length > 1) csvContent += `Table ${index + 1}\n`;

      const rows = table.querySelectorAll("tr");

      rows.forEach(row => {
        const cells = Array.from(row.children).map(cell => {
          const text = getPlainTextFromCell(cell);
          return `"${text.replace(/"/g, '""')}"`;
        });
        csvContent += cells.join(",") + "\n";
      });

      csvContent += "\n"; // spacing
    });

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "tables_export.csv";
    a.click();
    URL.revokeObjectURL(url);
  };

   return (
    <>
      <div className="agents_wrapper pt-4 pb-4 m-2">
        <div className="container-fluid">
          <div className="agents_head_block">
            <h5 className="agents_head">Agents (Notes)</h5>
          </div>
          <div className="row">

            <AgentsTabs activeTab={activeTab} setActiveTab={setActiveTab} />

            <div className="container-fluid">
               {activeTab === "closure" && (
                  <Closure
                    contentRef={contentRef}
                    copied={copied}
                    handleCopy={handleCopy}
                    exportTablesToCSV={exportTablesToCSV}
                  />
               )}
            </div>

            <div className="container-fluid">
               {activeTab === "champion" && (
                  <Champion
                    contentRef={contentRef}
                    copied={copied}
                    handleCopy={handleCopy}
                    exportTablesToCSV={exportTablesToCSV}
                  />
               )}
            </div>

            <div className="container-fluid">
               {activeTab === "delivery_excellence" && (
                  <DeliveryExcellence
                    contentRef={contentRef}
                    copied={copied}
                    handleCopy={handleCopy}
                    exportTablesToCSV={exportTablesToCSV}
                  />
               )}
            </div>

            <div className="container-fluid">
               {activeTab === "renewal" && (
                  <Renewal
                    contentRef={contentRef}
                    copied={copied}
                    handleCopy={handleCopy}
                    exportTablesToCSV={exportTablesToCSV}
                  />
               )}
            </div>

          </div>
        </div>
      </div>
    </>
  );
}
